import { CandidateStatus } from 'generated-graphql/types';

export const actionCandidateStatusOptions = [
  CandidateStatus.Rejected,
  CandidateStatus.NotProgressing,
  CandidateStatus.Progressing,
  CandidateStatus.ShortListed,
  CandidateStatus.Review,
  CandidateStatus.InterviewStage_1,
  CandidateStatus.InterviewStage_2,
  CandidateStatus.Offer
];
